import {
	RECEIVE_DOMAINS,
	ADD_DOMAIN,
	REMOVE_DOMAIN,
	UNBLOCK_DOMAIN,
	BLOCK_ALL_DOMAINS,
} from "./actions";

export default function domainsReducer(
	state = {
		is_fetching: false,
		domains: [],
	},
	action
) {
	let new_state = Object.assign({}, state);
	switch (action.type) {
		case RECEIVE_DOMAINS:
			new_state.is_fetching = false;
			new_state.domains = action.domains;
			return new_state;
		case ADD_DOMAIN:
			let domain_already_exists = state.domains.some((domain) => {
				return domain.site === action.domain;
			});
			if (!domain_already_exists) {
				new_state.domains = [{ site: action.domain }, ...state.domains];
			}
			return new_state;
		case REMOVE_DOMAIN:
			new_state.domains = state.domains.filter((domain) => {
				return domain.site !== action.domain;
			});
			return new_state;
		case UNBLOCK_DOMAIN:
			state.domains.forEach((domain, index) => {
				let domain_matches = action.domain.indexOf(domain.site) === 0;
				if (domain_matches) {
					new_state.domains[index] = {
						site: domain.site,
						unblock_until_timestamp: action.unblock_until_timestamp,
					};
				}
			});

			return new_state;
		case BLOCK_ALL_DOMAINS:
			new_state.domains = state.domains.map((domain) => {
				return {
					site: domain.site,
				};
			});
			return new_state;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../shared/store/domains/reducer.js